import type { ChangeEvent } from 'react';
import { Input } from '@savvy-kit/components/input';
import { cn } from '@savvy-kit/lib/utils';

import type { InputCellContentProps } from '../../types/cell-types';

export function InputCellContent({ value, onChange, placeholder, disabled, className }: InputCellContentProps) {
  function handleChange(e: ChangeEvent<HTMLInputElement>) {
    onChange?.(e.target.value);
  }

  return (
    <Input
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      disabled={disabled}
      className={cn('h-8', className)}
    />
  );
}
